import { useState } from 'react';

import RosterViewByDuty from './RosterViewByDuty';
import RosterViewByEmployee from './RosterViewByEmployee/RosterViewByEmployee';

export default function Teamroster() {
  const [rosterView, setRosterView] = useState<'employees' | 'duties'>(
    'employees'
  );
  const onRosterViewChanged = (rosterView: 'employees' | 'duties') => {
    setRosterView(rosterView);
  };
  if (rosterView === 'employees') {
    return (
      <RosterViewByEmployee
        portal="employee"
        onRosterViewChanged={onRosterViewChanged}
      />
    );
  }
  return (
    <RosterViewByDuty
      portal="employee"
      onRosterViewChanged={onRosterViewChanged}
    />
  );
}
